export const USER_ACCESS_TYPES = {
  GUEST: 0,
  FSP: 1,
  ON_DEMAND: 2,
  MEMBER: 9,
};
